import React from 'react';
import ReactDOM from 'react-dom/client';
import './root.css'
import './pages/general.css'
import Routess from './pathes';
import Preloader from './componets/layout/preloader';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
       <Preloader />

<Routess/>
  </React.StrictMode>
);

